module.exports = __webpack_public_path__ + "static/3-753bde6cb2fe6b559ee4157b57ee7eac.jpg";